import {lazy} from 'react';

export const PinterestLazy = lazy(() => import(/* webpackChunkName: "pinterest" */ '.'));
